import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';

import { TownPulseCard } from '@/features/discovery/TownPulseCard';
import { TrendingTags } from '@/features/discovery/TrendingTags';

import { FeedFilters } from './FeedFilters';
import { useFeedFilters } from './useFeedFilters';

/**
 * The right-hand column on wide screens (spec §9.3).
 *
 * It reads the same URL-backed filter state as the feed rather than being
 * handed a prop, so the two cannot drift — and a filter changed here updates
 * the URL, which is what the feed is driven by. The pulse and the trending tags
 * follow the same place selection, so the column always describes whatever the
 * reader is currently looking at.
 */
export function FeedSidebar() {
  const api = useFeedFilters();
  const { country, town, tags } = api.filters;

  const place: Record<string, string> = {};
  if (country) place.country = country;
  if (country && town) place.town = town;

  return (
    <Stack spacing={2}>
      <Card sx={{ p: 2 }}>
        <FeedFilters api={api} />
      </Card>

      <TownPulseCard country={country} town={town} />

      <TrendingTags params={place} selected={tags} onToggle={api.toggleTag} />
    </Stack>
  );
}
